export default __webpack_public_path__ + "static/media/box.9fb8c608.svg";